import React from 'react';
import { useSiteContent } from '../hooks/useSiteContent';
import './Legal.css';

const Imprint = () => {
  const { content: impressum, loading } = useSiteContent('impressum');

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Helper to render text with line breaks
  const renderText = (text) => {
    if (!text) return null;
    return text.split('\n').map((line, i) => (
      <React.Fragment key={i}>
        {line}
        {i < text.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <div className="legal-page">
      <section className="page-hero">
        <div className="container">
          <h1 className="display-medium">Impressum</h1>
        </div>
      </section>

      <section className="legal-content-section">
        <div className="container">
          <div className="legal-content">
            <div className="legal-section">
              <h2 className="heading-3">Angaben gemäß § 5 TMG</h2>
              <p className="body-medium">
                {impressum.company_name}<br />
                Inhaber: {impressum.owner}<br />
                {impressum.address}<br />
                {impressum.zip_city}<br />
                Deutschland
              </p>
            </div>

            <div className="legal-section">
              <h2 className="heading-3">Kontakt</h2>
              <p className="body-medium">
                Telefon: <a href={`tel:${impressum.phone}`}>{impressum.phone}</a><br />
                E-Mail: <a href={`mailto:${impressum.email}`}>{impressum.email}</a>
              </p>
            </div>

            {impressum.tax_id && (
              <div className="legal-section">
                <h2 className="heading-3">Umsatzsteuer-ID</h2>
                <p className="body-medium">
                  {impressum.tax_id_label || 'Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:'}<br />
                  {impressum.tax_id}
                </p>
              </div>
            )}

            <div className="legal-section">
              <h2 className="heading-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
              <p className="body-medium">
                {impressum.responsible_person || impressum.owner}<br />
                {impressum.address}<br />
                {impressum.zip_city}
              </p>
            </div>

            {impressum.additional_info && (
              <div className="legal-section">
                <h2 className="heading-3">Weitere Angaben</h2>
                <p className="body-medium">
                  {renderText(impressum.additional_info)}
                </p>
              </div>
            )}

            {impressum.eu_streitschlichtung && (
              <div className="legal-section">
                <h2 className="heading-3">EU-Streitschlichtung</h2>
                <p className="body-medium">
                  {renderText(impressum.eu_streitschlichtung)}
                </p>
              </div>
            )}

            {impressum.verbraucherstreitbeilegung && (
              <div className="legal-section">
                <h2 className="heading-3">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
                <p className="body-medium">
                  {renderText(impressum.verbraucherstreitbeilegung)}
                </p>
              </div>
            )}

            {impressum.haftung_inhalte && (
              <div className="legal-section">
                <h2 className="heading-3">Haftung für Inhalte</h2>
                <p className="body-medium">
                  {renderText(impressum.haftung_inhalte)}
                </p>
              </div>
            )}

            {impressum.haftung_links && (
              <div className="legal-section">
                <h2 className="heading-3">Haftung für Links</h2>
                <p className="body-medium">
                  {renderText(impressum.haftung_links)}
                </p>
              </div>
            )}

            {impressum.urheberrecht && (
              <div className="legal-section">
                <h2 className="heading-3">Urheberrecht</h2>
                <p className="body-medium">
                  {renderText(impressum.urheberrecht)}
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Imprint;
